import React, { useEffect, useState } from "react"
import { initialize, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import {
  Card,
  CardBody,
  Row,
  Col,
  Nav,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import { connect } from "react-redux"
import { getBooking, getBookingType, resetBooking } from "store/actions"
import validate from "./bookingValidation"
import BookingsSetup from "./bookingsSetup"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"

let Booking = ({
  feature,
  design,
  isEventFeature,
  selectedEvent,
  getBookingType,
  getBooking,
  resetBooking,
  selectedBooking,
  initializeForm,
  bookingTypes,
  handleSubmit,
  vendorConfig,
}) => {
  const [sortedCalendars, setSortedCalendars] = useState([])
  const TABS = {
    BOOKINGS: 1,
    HYPERLINKS: 2,
  }
  const [activeTab, setActiveTab] = useState(TABS.BOOKINGS)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    if (selectedEvent?.business_unit_id) {
      getBookingType({ hide_bu: true })
    } else {
      getBookingType({
        business_unit_id: selectedEvent?.business_unit_id,
      })
    }
    getBooking({ menu_item_id: feature.id })
    return () => {
      resetBooking()
    }
  }, [])

  useEffect(() => {
    if (
      selectedBooking?.booking_type_ids &&
      selectedBooking?.booking_type_ids.length > 0
    ) {
      initializeForm(selectedBooking?.booking_type_ids)
    }
  }, [selectedBooking])

  useEffect(() => {
    if (bookingTypes && bookingTypes?.length > 0) {
      let data = [...bookingTypes]
      data?.sort((a, b) => {
        const calendarA = a?.calendar?.name?.toUpperCase()
        const calendarB = b?.calendar?.name?.toUpperCase()
        if (calendarA < calendarB) {
          return -1
        }
        if (calendarA > calendarB) {
          return 1
        }
        if (calendarA === calendarB) {
          if (a?.name?.toUpperCase() < b?.name?.toUpperCase()) {
            return -1
          }
          if (a?.name?.toUpperCase() > b?.name?.toUpperCase()) {
            return 1
          }
          return 0
        }
      })
      setSortedCalendars(data)
    }
  }, [bookingTypes])

  return (
    <Card>
      <CardBody className="shadow-sm">
        {isEventFeature &&
        (vendorConfig?.nfc_hyperlinks ||
          vendorConfig?.communication_hyperlinks) ? (
          <React.Fragment>
            <Row>
              <Col>
                <Nav pills tabs>
                  <NavLink
                    className={markIfIsActive(TABS.BOOKINGS)}
                    onClick={() => {
                      setActiveTab(TABS.BOOKINGS)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>
                      {feature?.placeholder}
                    </span>
                  </NavLink>
                  <NavLink
                    className={markIfIsActive(TABS.HYPERLINKS)}
                    onClick={() => {
                      setActiveTab(TABS.HYPERLINKS)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>Hyperlinks</span>
                  </NavLink>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={TABS.BOOKINGS} style={{ animation: "none" }}>
                    <BookingsSetup
                      feature={feature}
                      sortedCalendars={sortedCalendars}
                      design={design}
                      handleSubmit={handleSubmit}
                    />
                  </TabPane>
                  <TabPane
                    tabId={TABS.HYPERLINKS}
                    style={{ animation: "none" }}
                  >
                    <MenuFeatureHyperlinks
                      event_id={selectedEvent?.id}
                      menu_feature={feature}
                    />
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          <BookingsSetup
            feature={feature}
            sortedCalendars={sortedCalendars}
            design={design}
            handleSubmit={handleSubmit}
          />
        )}
      </CardBody>
    </Card>
  )
}

Booking = reduxForm({
  form: FORM_NAMES.CREATE_BOOKING_FEATURE,
  validate,
})(Booking)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  bookingTypes: state.Bookings.bookingTypes,
  selectedBooking: state.Bookings.booking,
  vendorConfig: state.clients.vendorConfig,
})

const mapDispatchToProps = dispatch => ({
  getBookingType: values => dispatch(getBookingType(values)),
  getBooking: value => dispatch(getBooking(value)),
  initializeForm: values =>
    dispatch(
      initialize(FORM_NAMES.CREATE_BOOKING_FEATURE, {
        bookings: values,
      })
    ),
  resetBooking: () => dispatch(resetBooking()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Booking)
